// extracted by mini-css-extract-plugin
module.exports = {"nav":"Nav_nav__lRHSl","brand":"Nav_brand__1waUE","account":"Nav_account__3X6dQ"};